export interface StandardAnswer {
  answer: string
  count: number
}

/** Parses one answer per line, optionally followed by `= count`, as typed in the builder. */
export function parseStandardAnswers(text: string): StandardAnswer[] {
  const merged = new Map<string, StandardAnswer>()
  for (const line of text.split('\n')) {
    const match = /^(.*?)(?:\s*=\s*(\d+))?\s*$/.exec(line.trim())
    const answer = match?.[1]?.trim() ?? ''
    if (!answer) continue
    const count = Math.max(1, Math.min(100_000, Number(match?.[2] ?? 1) || 1))
    const key = answer.toLowerCase()
    const existing = merged.get(key)
    merged.set(key, existing ? { ...existing, count: existing.count + count } : { answer, count })
  }
  return [...merged.values()].slice(0, 50)
}

export function formatStandardAnswers(answers: StandardAnswer[]): string {
  return answers.map((entry) => `${entry.answer} = ${entry.count}`).join('\n')
}
